export function kakaoTrack(method) {
  const pixelInstance = window.Phoenix.kakaoPixelInstance;
  if (!pixelInstance || typeof pixelInstance[method] !== 'function') return;
  pixelInstance[method]();
}
